import { Reducer, Action } from 'redux'
import {
  ISpotBiddingConfigState,
  ISpotBiddingConfig,
} from 'apps/spot-quote-control-panel/types/spotBiddingConfig'
import {
  GET_SPOT_BIDDING_CONFIG_ACTION_TYPES,
  CREATE_SPOT_BIDDING_CONFIG_ACTION_TYPES,
  UPDATE_SPOT_BIDDING_CONFIG_ACTION_TYPES,
  DELETE_SPOT_BIDDING_CONFIG_ACTION_TYPES,
} from 'apps/spot-quote-control-panel/utils/actions/spotBiddingConfig'

const {
  GET_SPOT_BIDDING_CONFIG_FAILURE,
  GET_SPOT_BIDDING_CONFIG_REQUEST,
  GET_SPOT_BIDDING_CONFIG_SUCCESS,
} = GET_SPOT_BIDDING_CONFIG_ACTION_TYPES

const {
  CREATE_SPOT_BIDDING_CONFIG_FAILURE,
  CREATE_SPOT_BIDDING_CONFIG_REQUEST,
  CREATE_SPOT_BIDDING_CONFIG_SUCCESS,
} = CREATE_SPOT_BIDDING_CONFIG_ACTION_TYPES

const {
  UPDATE_SPOT_BIDDING_CONFIG_FAILURE,
  UPDATE_SPOT_BIDDING_CONFIG_REQUEST,
  UPDATE_SPOT_BIDDING_CONFIG_SUCCESS,
} = UPDATE_SPOT_BIDDING_CONFIG_ACTION_TYPES

const {
  DELETE_SPOT_BIDDING_CONFIG_FAILURE,
  DELETE_SPOT_BIDDING_CONFIG_REQUEST,
  DELETE_SPOT_BIDDING_CONFIG_SUCCESS,
} = DELETE_SPOT_BIDDING_CONFIG_ACTION_TYPES

interface ISuccessAction extends Action<string> {
  payload: {
    spotBiddingConfig: ISpotBiddingConfig
  }
}

interface IErrorAction extends Action<string> {
  error: string
}

const defaultSpotBiddingConfig: ISpotBiddingConfig = {
  id: '',
  shipperApplication: undefined,
  configType: undefined,
  configName: '',
  spotBiddingRules: {
    sameDayRule: [],
    equipmentRules: [],
    mileageRules: [],
    geographicInboundRules: [],
    geographicOutboundRules: [],
    laneGeographicRules: [],
    contractRules: [],
    countLoadsQuotedRules: [],
    laneTierRules: [],
    distanceToMarketCenterRules: [],
    dateRules: [],
    dropRules: [],
    proximalHourRules: [],
    geoDateRules: [],
    onlyBidOnRules: [],
    appointmentTimeMileagePickupRules: [],
    appointmentTimeMileageDeliveryRules: [],
    carrierWaitTimeRules: [],
    multiStopRules: [],
    transitDifferenceRules: [],
  },
  shipperApplications: [],
}

const defaultState: ISpotBiddingConfigState = {
  fetching: false,
  spotBiddingConfig: defaultSpotBiddingConfig,
}

type SpotBiddingConfigAction = ISuccessAction | IErrorAction

const spotBiddingConfigReducer: Reducer<ISpotBiddingConfigState, SpotBiddingConfigAction> = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case GET_SPOT_BIDDING_CONFIG_REQUEST: {
      return {
        ...state,
        fetching: true,
      }
    }
    case GET_SPOT_BIDDING_CONFIG_SUCCESS: {
      const {
        payload: { spotBiddingConfig },
      } = action as ISuccessAction
      return {
        ...state,
        fetching: false,
        spotBiddingConfig,
      }
    }
    case GET_SPOT_BIDDING_CONFIG_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: (action as IErrorAction).error,
      }
    }
    case CREATE_SPOT_BIDDING_CONFIG_REQUEST:
    case UPDATE_SPOT_BIDDING_CONFIG_REQUEST: {
      return {
        ...state,
        fetching: true,
      }
    }
    case CREATE_SPOT_BIDDING_CONFIG_SUCCESS:
    case UPDATE_SPOT_BIDDING_CONFIG_SUCCESS: {
      const {
        payload: { spotBiddingConfig },
      } = action as ISuccessAction
      return {
        ...state,
        fetching: false,
        spotBiddingConfig,
        error: undefined,
      }
    }
    case CREATE_SPOT_BIDDING_CONFIG_FAILURE:
    case UPDATE_SPOT_BIDDING_CONFIG_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: (action as IErrorAction).error,
      }
    }

    case DELETE_SPOT_BIDDING_CONFIG_REQUEST: {
      return {
        ...state,
        fetching: true,
        error: undefined,
      }
    }
    case DELETE_SPOT_BIDDING_CONFIG_SUCCESS: {
      return {
        ...state,
        fetching: false,
        error: undefined,
      }
    }
    case DELETE_SPOT_BIDDING_CONFIG_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: (action as IErrorAction).error,
      }
    }

    default:
      return state
  }
}

export default spotBiddingConfigReducer
